import http from "@/utils/http";

export default {
  getPoints(source) {
    return http.get(`/api/common/${source}/points/`);
  },
  getResults(source, pointIds, startDate, endDate, simulationOnly = false) {
    return http.get(`/api/common/${source}/results/`, {
      params: {
        point_ids: pointIds.join(","),
        start_date: startDate,
        end_date: endDate,
        simulation_only: simulationOnly
      }
    });
  },
  getReservoirInfos(source, startDate, endDate) {
    return http.get(`/api/common/${source}/reservoir-infos/`, {
      params: {
        start_date: startDate,
        end_date: endDate
      }
    });
  },
  getReservoirInfosByDay(source, day) {
    return http.get(`/api/common/${source}/reservoir-infos/`, {
      params: {
        day
      }
    });
  },
  getAlerts(
    source,
    {
      perPage: per_page,
      currentPage: current_page,
      startDate: start_date,
      endDate: end_date,
      alertType,
      alertLevel,
      alertCategory,
      title,
      description
    }
  ) {
    if (Array.isArray(alertType)) {
      alertType = alertType.join(",");
    }

    if (Array.isArray(alertLevel)) {
      alertLevel = alertLevel.join(",");
    }

    if (Array.isArray(alertCategory)) {
      alertCategory = alertCategory.join(",");
    }

    return http.get(`/api/common/${source}/alerts/`, {
      params: {
        per_page,
        current_page,
        start_date,
        end_date,
        alert_type: alertType,
        alert_level: alertLevel,
        alert_category: alertCategory,
        title,
        description
      }
    });
  },
  getSensors(source) {
    return http.get(`/api/common/${source}/sensors/`);
  },
  getReadings(source, { sensors, startDate, endDate }) {
    return http.get(`/api/common/${source}/sensors/readings/`, {
      params: {
        sensors: sensors.join(","),
        start_date: startDate,
        end_date: endDate
      }
    });
  }
};

const visualization = {
  getConfig(source) {
    return http.get(`/api/common/${source}/visualization/config/`);
  },
  generate(source, epoch) {
    return http.post(`/api/common/${source}/visualization/generate/`, {
      epoch
    });
  },
  getStatus(source) {
    return http.get(`/api/common/${source}/visualization/generate/status/`);
  },
  stopGenerate(source) {
    return http.post(
      `/api/common/${source}/visualization/generate/stop/`,
      null
    );
  }
};

const simulator = {
  start(source) {
    return http.post(`/api/common/${source}/simulator/start/`, null);
  },
  getStatus(source) {
    return http.get(`/api/common/${source}/simulator/status/`);
  },
  stop(source) {
    return http.post(`/api/common/${source}/simulator/stop/`, null);
  },
  validate(source) {
    return http.get(`/api/common/${source}/simulator/validate/`);
  }
};

export { visualization, simulator };
